export function cleanAccount(id: string): string {
    return id.replace(/^polymarket:/, '');
}

export function shortAccount(id: string): string {
    const clean = cleanAccount(id);
    if (clean.length <= 14) return clean;
    return clean.slice(0, 6) + '\u2026' + clean.slice(-4);
}

export function formatPnl(value: number): string {
    const sign = value >= 0 ? '+' : '';
    return `${sign}${value.toFixed(2)}`;
}

export function formatPnlShort(v: number | null | undefined): string {
    if (v == null) return '—';
    const abs = Math.abs(v);
    const sign = v < 0 ? '-' : '+';
    if (abs >= 1_000_000) return `${sign}$${(abs / 1_000_000).toFixed(1)}M`;
    if (abs >= 1_000) return `${sign}$${(abs / 1_000).toFixed(1)}k`;
    return `${sign}$${abs.toFixed(0)}`;
}

export function formatPct(v: number | null | undefined): string {
    if (v == null) return '—';
    return `${(v * 100).toFixed(1)}%`;
}

export function formatPortfolio(v: number | null | undefined): string {
    if (v == null) return '—';
    if (v >= 1_000_000) return `$${(v / 1_000_000).toFixed(1)}M`;
    if (v >= 1_000) return `$${(v / 1_000).toFixed(1)}k`;
    return `$${v.toFixed(0)}`;
}

export function formatCount(v: number | null | undefined): string {
    if (v == null) return '—';
    if (v >= 1_000) return `${(v / 1_000).toFixed(1)}k`;
    return String(v);
}
